import { DisplayMode, EMPTY_VALUE_TEXT } from './constants';
import type { AvailableInput } from './types';
import type { PromptDisplayMode } from 'web';

/**
 * Get the display properties for a tag based on the display mode, showLabel/showValue control visibility.
 * - SOURCE_VALUE: show both label and value
 * - SOURCE: show only label
 * - VALUE: show only value
 */
export function getTagDisplay(inputInfo: AvailableInput, displayMode: PromptDisplayMode) {
  const { label, value, isIterator: isInputIterator } = inputInfo;
  // Treat whitespace-only strings as empty
  const hasValue = value && value.trim().length > 0;
  const displayValue = hasValue ? value : EMPTY_VALUE_TEXT;
  const isIterator = isInputIterator ?? false;

  switch (displayMode) {
    case DisplayMode.SOURCE:
      return { label, value: displayValue, isIterator, showLabel: true, showValue: false };
    case DisplayMode.VALUE:
      return { label, value: displayValue, isIterator, showLabel: false, showValue: true };
    case DisplayMode.SOURCE_VALUE:
    default:
      return { label: `${label}: `, value: displayValue, isIterator, showLabel: true, showValue: true };
  }
}
